import React from 'react'
import SomethingWentWrong from '../../assets/images/something-went-wrong.png'
import './ReservationErrorBoundary.scss'

const ReservationErrorBoundary = ({children, errors = null}) => {
  return (
    <>
      {!!errors && (
        <div className="c-res-mod ap-error-boundary">
          <div className="ap-error-boundary__hero-img">
            <img src={SomethingWentWrong} alt="Something went wrong" />
          </div>
          {(errors || []).length > 0 && (
            <div className="ap-error-boundary__msg-list">
              {(errors || []).map(e => (
                <div>
                  <span className="ap-typography">{e}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
      {!errors && children}
    </>
  )
}

export default ReservationErrorBoundary
